// extracted by mini-css-extract-plugin
export default {"container":"PostCard_container__qe1gU","main":"PostCard_main__Bb9oZ","header":"PostCard_header__IG02c","content":"PostCard_content__8CFKP","footer":"PostCard_footer__DlAZT"};